<script>
import { FormErrors } from "@/models/form/form_error";

export default {
  props: {
    validations: {
      required: true,
      type: Object
    }
  },
  computed: {
    errors() {
      if (!this.invalid) {
        return [];
      }
      return Object.keys(this.validations.$params).reduce(
        (errors, validator) => {
          if (!this.validations[validator]) {
            errors.push(`${FormErrors[validator]}`);
          }
          return errors;
        },
        []
      );
    },
    invalid() {
      return this.validations.$dirty && this.validations.$invalid;
    }
  },
  render() {
    return this.$scopedSlots.default({
      errors: this.errors,
      invalid: this.invalid
    });
  }
};
</script>
